import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetApplicantsByVacancy } from 'src/hooks/applicants/get-applicants-by-vacancy.hook';

import { ApplicantsListTable } from './components/applicants-list-table';
import { ApplicantsWrapper, HeaderContainer } from './applicants.styles';
import { ApplicantsTableFilter } from './components/applicants-table-filter';
import { getFilterButtonTitle } from './applicants.helpers';

const Applicants = ({ vacancyId }: { vacancyId: string }) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const [filters, setFilters] = useState<string[]>([]);
  const [isOpenedTableFilter, setIsOpenedTableFilter] = useState(false);
  const { applicants, paginationConfig, onTableChange } = useGetApplicantsByVacancy(
    vacancyId,
    filters
  );

  return (
    <ApplicantsWrapper>
      <ApplicantsTableFilter
        isOpened={isOpenedTableFilter}
        onClose={() => setIsOpenedTableFilter(false)}
        setFilters={setFilters}
        filters={filters}
      />
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('vacancies:labels.applicants')}
        </Typography>
        <Button
          type="primary"
          ghost
          icon={ICONS.editAlt}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
          onClick={() => setIsOpenedTableFilter(true)}
        >
          {getFilterButtonTitle(t, filters)}
        </Button>
      </HeaderContainer>
      <ApplicantsListTable
        dataSource={applicants}
        paginationConfig={paginationConfig}
        onTableChange={onTableChange}
      />
    </ApplicantsWrapper>
  );
};

export default Applicants;
